import React from 'react';
import './css/SearchResultCard.css';
import { DEFAULT_USER_AVATAR } from '../../shared/constants/common';
import { isUserLoggedIn, getUserRole } from '../../shared/utils/function';
import { ROLE } from '../../shared/constants/common';
import { useNavigation } from '../../shared/utils/useNavigation';
import { fireAndForgetAddCreatorCategories } from '../../shared/actions/contentAction';
import LazyImage from '../../components/LazyImage';
import { getCreatorListSubtitle } from '../../shared/utils/paymentUtil';
import { formatProfileTag } from '../../shared/utils/function';

const RecentResultCard = ({
  noImage = false,
  noSubLine,
  item,
  vatPercentage = 0,
  avatarClassName = '',
  showIcon = true,
  onClick = null
}) => {
  const isLoggedIn = isUserLoggedIn();
  const userRole = getUserRole();
  const navigate = useNavigation();
  const isCategory = item?.isCategory === true;
  const displayUsername = isCategory
    ? formatProfileTag(item.categoryName)
    : `@${item.username || ''}`;
  const subtitle = !isCategory ? getCreatorListSubtitle(item, vatPercentage) : null;

  // Handle creator click
  const handleCreatorClick = () => {
    // If it's a category, only call onClick and return (don't navigate to profile)
    if (isCategory) {
      if (onClick && typeof onClick === 'function') {
        onClick(item);
      }
      return;
    }

    // Add creator categories to user's category list
    if (isLoggedIn && userRole === ROLE.USER && item && typeof item === 'object') {
      fireAndForgetAddCreatorCategories(item);
    }

    // Call optional onClick callback (e.g., to save to recent searches)
    if (onClick && typeof onClick === 'function') {
      onClick(item);
    }

    navigate.toProfile(item.username);
  };

  return (
    <div
      className={`jh-search-result-item ${noSubLine ? 'cm_noSubLine' : ''} ${noImage ? 'noImage' : ''}`}
      onClick={handleCreatorClick}
    >
      {!noImage && !isCategory && (
        <LazyImage
          src={item.profile_picture}
          alt={displayUsername}
          className={`jh-search-result-avatar ${avatarClassName}`}
          onError={(e) => {
            e.target.src = DEFAULT_USER_AVATAR;
          }}
        />
      )}

      <div className={`jh-search-result-info ${isCategory ? 'jh-search-result-category-info' : ''}`}>
        <p className="jh-search-result-username">
          {displayUsername}
          {showIcon && item.isTrending && (
            <span className="jh-search-result-trending-badge ml-1">
              <i className="fas fa-fire jh-search-section-icon jh-trending-icon"></i>
            </span>
          )}
          {showIcon && item.isFeature && (
            <span className="jh-search-result-feature-badge ml-1">
              <i className="fas fa-star jh-search-section-icon jh-featured-icon"></i>
            </span>
          )}
        </p>
        {subtitle && (
          <p className="jh-search-result-price">
            {subtitle}
          </p>
        )}
        {isCategory && item.categoryCount !== undefined && (
          <p className="jh-search-result-price">
            {item.categoryCount} {item.categoryCount === 1 ? 'creator' : 'creators'}
          </p>
        )}
      </div>
    </div>
  );
};

export default RecentResultCard;
